import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=75c28d26&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
import style0 from "./Profile.vue?vue&type=style&index=0&id=75c28d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c28d26",
  null
  
)

export default component.exports